import React, { useEffect } from "react";
import "./Help.css";
import { NavLink, Route, Routes } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Contact from "./Contact";

// HelpTopic Component - Modernized
const HelpTopic = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <span className="supportContentTitle">About DButler</span>
      <div className="supportContentBox">
        <span className="supportContentSubheading">Our mission</span>
        <span className="supportContentText">
          Connect Sellers and Buyers for their business requirements through
          most efficient and advanced platform.
        </span>
        <span className="supportContentSubheading">Our platform</span>
        <span className="supportContentText">
          Unique application/platform that will serve both suppliers and
          shops. A platform that is a network, database, marketplace and
          digital area for doing business fast and easy in the manner of
          digital age that we live in.
        </span>
      </div>
    </>
  );
};

// FAQ Component - Modernized
const FAQ = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <span className="supportContentTitle">Frequently asked question</span>
      <div className="supportContentBox">
        <span className="supportContentSubheading">
          In what way will your system benefit my company?
        </span>
        <span className="supportContentText">
          Here are some of the many values that D'Butler offers: Option to add
          any item on the platform and offer it to all the shops listed with
          us; Option to be featured on the dashboard of every shop in the
          system so they can choose you before the competition; Order
          management and statistics; In the future, a full inventory
          management system; Tracking of orders and deliveries; Data and
          statistics on every aspect of business. This includes sales, orders,
          items, customers and so on.
        </span>
        <span className="supportContentSubheading">
          What will you do to help us to achieve growth in sales and how will
          it be achieved?
        </span>
        <span className="supportContentText">
          Our service is the platform that will help you reach more audiences
          and more potential clients. More people will hear about your company
          and you will gain more exposure. We can also give training and
          advice on how to maximize and use the full potential of this
          platform, and we can offer our users to be featured on our site so
          that they can attract more customers.
        </span>
        <span className="supportContentSubheading">
          What kind of guarantee can you give to us?
        </span>
        <span className="supportContentText">
          D'Butler guarantees a fair playground and rules for everyone using
          their platform. How will the cleints use it and who will be more
          competitive is up to the users themselves. We have provided and will
          continue to add new ways to help our clients grow, promote and make
          the best use of our platform and their time.
        </span>
        <span className="supportContentSubheading">
          Do you have competitors for the product available to me and what is
          the solution in case I do not want the presence of competitors?
        </span>
        <span className="supportContentText">
          D'Butler will be a mirror image of a real world market. So if there
          is competition on the outside it might happen inside the system
          also. We can offer the supplier an option to compare the prices with
          others (something he cannot do easily in the real world), offer his
          products to more shops, and in the end be competitive in other ways,
          like faster delivery, lower minimum order and so on.
        </span>
        <span className="supportContentSubheading">
          Can I check your system by sharing the details of the plan with us
          to show it to our engineers?
        </span>
        <span className="supportContentText">
          There will be a demo available soon that the supplier can use to
          test the system and see how it works.
        </span>
        <span className="supportContentSubheading">
          Is there a limitation on the number of orders and who is in charge
          of the delivery?
        </span>
        <span className="supportContentText">
          There is no limitation on the number of orders. Some shops order
          more frequently than others. Transportation is the responsibility of
          the supplier, and they will decide on the delivery times which will
          be visible to buyers at all time.
        </span>
        <span className="supportContentSubheading">
          How can I be sure that the system is working well and that there are
          no requests not counted in the system?
        </span>
        <span className="supportContentText">
          D'Butler system will be tested. We will have easy feedback and
          reporting options in case there is an issue. And we will have a
          helpline active that will take care of all requests
        </span>
        <span className="supportContentSubheading">
          The cost of each van sale is 16000 QR per month including the
          expenses of the car, petrol and others. Will your service cover my
          monthly expenses?
        </span>
        <span className="supportContentText">
          With D'Butler the cost to maintain each van should go down
          drastically. Not only should they make less deliveries (now they can
          only deliver when there is an order, not drive around searching for
          shops), but we also plan to have best automatic route implemented in
          the near future, car park implementation to keep better track of the
          vehicles, and so on.
        </span>
        <span className="supportContentSubheading">
          I already have 30 products and 5 vendors. They are covering all the
          market with vans, and the plan has been already distributed to them.
          Why would I change my plan now?
        </span>
        <span className="supportContentText">
          There is no need to change any of your plans. D'Butler is a
          supplement to the suppliers current service and not a completely new
          delivery plan. Supplier should be able to easily include orders from
          D'Butler into the already established delivery routes and increase
          his sales. Only potential is the one to be visible to every possible
          customer in Qatar.
        </span>
        <span className="supportContentSubheading">
          Do you have an alternative plan to help grow my sales without
          distracting my sales staff?
        </span>
        <span className="supportContentText">
          We have left it to the supplier to decide what is the minimum order
          and what is the time required for the delivery. This should give
          them a lot of flexibility when it comes to implementing D'Butler
          into their current distribution plan. For example, they could decide
          to deliver once a week, possibly on the day they know they have the
          least amount of deliveries and start from there. This should give
          them access to all the benefits of the D'Butler system and increase
          their sales, withouth distracting their staff or their current
          business operations.
        </span>
      </div>
    </>
  );
};

// Conditions Component - Modernized
const Conditions = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <span className="supportContentTitle">DButler Service Agreement</span>
      <div className="supportContentBox">
        <span className="supportContentSubheading">1. Definitions</span>
        <span className="supportContentText">
          1.1. "Seller" or Partner denotes the wholesale distributors and/or
          producers registered with DOHA CART as Partner
        </span>
        <span className="supportContentText">
          1.2. "D'Butler": denotes the application using for transaction
          between suppliers and Doha Cart
        </span>
        <span className="supportContentText">
          1.3. "Buyer" denotes customer who buys goods from Seller and whose
          name is printed on the Order.
        </span>
        <span className="supportContentText">
          1.4. "Contract" – any order and Order Confirmation is considered as
          contract (incorporating any Special Conditions)
        </span>
        <span className="supportContentText">
          1.5. "Goods" – any final or intermediary products ordered by the
          "buyer" (including any instalment of the goods or any parts for them
          which the Seller is to sell in accordance with these Terms and
          Conditions).
        </span>
        <span className="supportContentText">
          1.6. "Order" – the Buyer's order for goods through s Electronic
          Ordering Platform of D'Butler
        </span>
        <span className="supportContentText">
          1.7."Multiple Orders"- there is more than one accepted Order of
          Goods by Seller
        </span>
        <span className="supportContentText">
          1.8. "Order Confirmation"- s electronic confirmation pursuant to
          Clause 3.3.
        </span>
        <span className="supportContentText">
          1.9. "Price" means Price means the price in which the seller/buyer
          agrees to sell/buy the listed product in the D'Butler app
        </span>
        <span className="supportContentText">
          1.10. "Terms and Conditions" - the standard terms and conditions of
          sale provided in this document.
        </span>
        <span className="supportContentSubheading">2. Basis of the sale</span>
        <span className="supportContentText">
          2.1. These Terms and Conditions and any Special Conditions will
          govern the Contract to the exclusion of any other terms, including
          any terms and conditions which the Partner may purport to apply
          under any purchase order, confirmation of order or other document.
        </span>
        <span className="supportContentSubheading">
          3. Orders and specifications
        </span>
        <span className="supportContentText">
          3.1. All Goods are offered for sale subject to the Seller's
          acceptance of the Order.
        </span>
        <span className="supportContentText">
          3.2. Minimum orders are subject to the policy of the supplier's
          listed in D'BUTLER.
        </span>
        <span className="supportContentText">
          3.3. No Order shall be deemed accepted by the Seller unless and
          until it is confirmed unconditionally by the Buyer with document.
        </span>
        <span className="supportContentText">
          3.4. Any document/letter published or submitted by the Seller to the
          Buyer which contains any descriptions, specifications, drawings, or
          prices of the Goods is published or submitted for guidance only.
        </span>
        <span className="supportContentText">
          3.5. The Seller reserves the right to make minor modifications in
          the design (if any) and specification of the Goods (in case of
          ordering pre-production goods) without notice to the Buyer, but
          agrees to notify the Buyer if any major material modifications which
          the Buyer shall be deemed to have accepted.
        </span>
        <span className="supportContentText">
          3.6. The seller shall ensure the maximum delivery time is 2 working
          days
        </span>
        <span className="supportContentSubheading">4. Price & payment</span>
        <span className="supportContentText">
          4.1. Doha Cart is liable to pay/transfer the Price directly to the
          seller as per the payment conditions mentioned in the invoice upon
          the sale of the Goods
        </span>
        <span className="supportContentText">
          4.2. The Doha Cart is entitled to enter agreement with Sellers for
          the convenient payment terms
        </span>
        <span className="supportContentText">
          4.3. The seller is not entitled to increase the prices of the
          products for minimum 3days once it listed with D'Butler application
          of DOHA CART
        </span>
        <span className="supportContentText">
          4.4. If any Price changes between the date of acceptance of the
          Buyer's order and delivery of the Goods by the Seller, the Seller is
          liable to deliver the products at the listed price at the time of
          order by the Buyer.
        </span>
        <span className="supportContentSubheading">5. Delivery</span>
        <span className="supportContentText">
          5.1. The Seller shall ensure the sufficient stock of listed items.
          The Seller has to monitor and notify the stock of goods time to time
          and update accordingly.
        </span>
        <span className="supportContentText">
          5.2. The Seller shall be delivered goods within 2 working days up on
          receiving the electronic copy of LPO (Local Purchase Order)
        </span>
        <span className="supportContentText">
          5.3. The place for delivery of the Goods will be agreed between the
          Seller and the Buyer and shown on the Order Confirmation. If no
          place for delivery is so shown, the Seller may deliver the Goods by
          either: (a) notifying the Buyer that the Goods are ready for
          collection from premises nominated by the Seller ("the Seller's
          premises); or (b) Delivering the Goods at any address agreed between
          the Seller and the Buyer.
        </span>
        <span className="supportContentText">
          5.4. In the case of delivery in accordance with Condition 6.3(a),
          the Seller will load the Goods when the Goods are collected from the
          Seller's premises and the Seller will be liable for any damage to
          the Goods or losses occurring during loading. In case of delivery in
          accordance with Condition 6.3(b), the Goods will be, or will be
          deemed to be, unloaded by the Buyer and the Buyer will be liable for
          any damage to the Goods or losses occurring during unloading.
        </span>
        <span className="supportContentText">
          5.5. Any dates quoted for delivery of the Goods are indicative only.
          Time for delivery will not be of the essence of the Contract and the
          Seller will not be liable for any loss or expenses sustained by the
          Buyer arising from a delay less than 12 hours in the delivery of the
          Goods howsoever caused.
        </span>
        <span className="supportContentText">
          5.6. However, the buyer has the right to cancel the order
        </span>
        <span className="supportContentTextSub">
          5.6.1. if, the Seller failed to deliver the order within even after
          12 hours from the confirmed time (2 working days).
        </span>
        <span className="supportContentTextSub">
          5.6.2. The products differ in terms of label, quantity, brand etc.
        </span>
        <span className="supportContentText">
          5.7. The Buyer or, where relevant, the representative to whom
          delivery is made in accordance with Condition 6.2, must inspect the
          Goods on delivery and sign the required proof of delivery document
          or collection acceptance document. A signature on that document will
          constitute conclusive evidence against the Buyer of receipt of the
          quantity of Goods indicated on that document free from any apparent
          defect or damage and in no circumstances will the Seller accept a
          return of Goods or any other liability in regard to apparent defect
          or damage where such Goods have previously been installed by or on
          behalf of the Buyer.
        </span>
        <span className="supportContentText">
          5.8. If the Goods are alleged to be damaged or defective on
          delivery, a description of the alleged damage or defect must be
          given in writing with proof at the time of delivery and signed by or
          on behalf of the Buyer or, where relevant, the person to whom
          delivery is made in accordance with Condition 6.2
        </span>
        <span className="supportContentText">
          5.9. The Seller reserves the right to make delivery of the Goods by
          instalments (if any, up on the availability of goods). However, it
          is the Buyer choice to accept the 2nd installment and cancel the
          order.
        </span>
        <span className="supportContentText">
          5.10. Goods shall not be returned to the Seller without prior
          arrangement confirmed in writing by the Buyer.
        </span>
        <span className="supportContentText">
          5.11. In the event, the Buyer requests a delay in delivery of the
          Goods, which request is made less than 12 hours prior to the agreed
          date for delivery, if not so the Seller reserves the right to
          charge, and the Buyer shall pay the full difference of any delivery
          cost of the Goods on the delayed date.
        </span>
        <span className="supportContentSubheading">6. Risk and property</span>
        <span className="supportContentText">
          6.1. Risk of damage to or loss of the Goods will pass to the Buyer;
          in case of Goods delivered at the Buyer's premises, at the time when
          the Seller notifies the Buyer that the Goods are available for
          collection in good condition/packing;
        </span>
        <span className="supportContentText">
          6.2. Notwithstanding delivery and the passing of risk in the Goods,
          property in the Goods will not pass from the Seller until the Seller
          has received in cash or cleared sums full payment of the Price (if
          deferred payment terms not mutually agreed) and all other sums which
          are due, owing or payable by the Buyer to the Seller in respect of
          the Contract or any other Contract between the Seller and the Buyer
          and any payment schedule
        </span>
        <span className="supportContentSubheading">7. Liability</span>
        <span className="supportContentText">
          7.1. DOHA CART will not be liable for any loss of the supplier due
          to (a) cancellation of orders due to delay in delivery (b)changes in
          quantity or price due to mismanagement of the partner staff, (c) any
          damages of goods while loading due to improper packaging.
        </span>
        <span className="supportContentText">
          7.2. DOHA CART will not be liable in any way for loss, damage, costs
          or expenses (including loss of profit) arising directly or
          indirectly from any failure or delay in performing any obligation
          under this Contract by reason of any event or circumstance outside
          the reasonable control of the Seller, (including but not limited
          to), any strikes, labor disputes, riots, insurrections, civil
          disturbances, natural calamities, shortages of labor or materials,
          fires‎ industrial action, failure of power supplies or equipment,
          Internet failures, electrical power ‎failures‎ government action or
          Act of God.
        </span>
        <span className="supportContentSubheading">
          8. Insolvency of the seller (partner)
        </span>
        <span className="supportContentText">
          8.1. If the DOHA CART reasonably believes that the Seller has or is
          about to cease trading or has become insolvent or has entered or is
          about to enter into receivership or liquidation, then DOHA CART may
          terminate the contract or suspend any further deliveries under the
          contract without any liability to DOHA CART itself.
        </span>
        <span className="supportContentSubheading">9. Notices</span>
        <span className="supportContentText">
          9.1. Any notice given or made under the Contract will be in writing
          (other than writing on the screen of a visual display unit or other
          similar device, which shall not be treated as writing for the
          purposes of this Clause).
        </span>
        <span className="supportContentSubheading">
          10. Governing law and jurisdiction
        </span>
        <span className="supportContentText">
          10.1. The Contract shall be governed by and construed in accordance
          with Qatar law.
        </span>
        <span className="supportContentText">
          10.2. The parties irrevocably agree that the courts of Qatar are to
          have non-exclusive jurisdiction to settle any disputes which may
          arise in connection with the Contract.
        </span>
        <span className="supportContentSubheading">
          11. Certification and testing of goods
        </span>
        <span className="supportContentText">
          11.1. Goods will only be tested to the standards as agreed in the
          order.
        </span>
        <span className="supportContentText">
          11.2. The Buyer shall be liable for the costs incurred for any
          certification or testing of goods unless otherwise agreed by the
          Seller in writing.
        </span>
        <span className="supportContentSubheading">12. Guarantee</span>
        <span className="supportContentText">
          12.1. Delivery of goods on the condition that the goods are supplied
          within the manufactures guidelines and are not modified and/or
          damaged through any action or inaction of the Buyer.
        </span>
        <span className="supportContentSubheading">
          13. Cencellation of order
        </span>
        <span>
          The Buyer shall have the right to cancel any order for goods made
          directly through the D'BUTLER' Electronic Traction Platform in the
          following circumstances:
        </span>
        <span className="supportContentText">
          13.1. For any reason, within 12 working hours after the seller
          receives the order
        </span>
        <span className="supportContentText">
          13.2. in the case of faulty or defective goods within 5 working days
          of receipt of the goods. Notice of the wish to cancel must be made
          by any one of the following means;
        </span>
        <span className="supportContentTextSub">
          a) by leaving it at or posting it to the address of Seller as
          mentioned in the contract (elsewhere)
        </span>
        <span className="supportContentTextSub">
          b) by emailing it from the authorized mail to the' seller's official
          mail
        </span>
        <span className="supportContentSubheading">
          14. Application and Acceptence of the terms
        </span>
        <span className="supportContentText">
          14.1. DOHA CART may amend any Terms at any time by posting the
          relevant amended and restated Terms on the Sites.  By continuing to
          access or use the Services or the Sites, you agree that the amended
          and restated Terms will apply to you.
        </span>
        <span className="supportContentText">
          14.2. As a condition of Partner (Seller who registered with
          D'BUTLER) access to and use of the Sites or Services, agree that the
          partner will comply with all applicable laws and regulations when
          accessing or using the Sites or Services.
        </span>
        <span className="supportContentText">
          14.3. The partner agree that (a) will not copy, reproduce, download,
          re-publish, sell, distribute or resell any services or any
          information, text, images, graphics, video clips, sound,
          directories, files, databases or listings, etc., available on or
          through the Sites, and (b) will not copy, reproduce, download,
          compile or otherwise use any site Content for the purposes of
          operating a business that competes with DOHA CART, or otherwise
          commercially exploiting the site content. systematic retrieval of
          site content from the sites to create or compile, directly or
          indirectly, a collection, compilation, database or directory
          (whether through robots, spiders, automatic devices or manual
          processes) without written permission from DOHA CART is prohibited.
          Use of any content or materials on the Sites for any purpose not
          expressly permitted in the Terms is prohibited.
        </span>
        <span className="supportContentText">
          14.4. The partner (Seller) agrees not to undertake any action which
          may undermine the integrity of s DOHA CART feedback system, such as
          leaving positive feedback for yourself using secondary Member IDs or
          through third parties or by leaving unsubstantiated negative
          feedback for another User.
        </span>
        <span className="supportContentText">
          14.5. DOHA CART and the Partner (Seller) are independent entities,
          and no agency, partnership, joint venture, employee-employer or
          franchiser-franchisee relationship is intended or created by the
          Terms
        </span>
        <span className="supportContentText">
          14.6. DOHA CART reserves the right in our sole discretion to remove,
          modify or reject any user content that the Partner ‎submit to, post
          or display on the DOHA CART site which we reasonably believe is
          unlawful, violates the ‎terms, could subject DOHA CART or our
          affiliates to liability, or is otherwise found inappropriate in ‎s
          DOHA CART sole discretion
        </span>
        <span className="supportContentSubheading">
          15. Provision of services
        </span>
        <span className="supportContentText">
          15.1. Seller shall register as a member with DOHA CART in order to
          access and use services. Further, DOHA CART reserves the right,
          without prior notice, to restrict access to or use of certain
          services (or any features within the Services) to paying users, or
          subject to other conditions that DOHA CART may impose in our
          discretion. 
        </span>
        <span className="supportContentText">
          15.2. DOHA CART may launch, change, upgrade, impose conditions to,
          suspend, or stop any services (or any features within the services)
          without prior notice except that in case of a fee-based Service,
          such changes will not substantially adversely affect the ability of
          such paying Users to enjoy that Service.
        </span>
        <span className="supportContentSubheading">
          16. Transactions between retailer and wholesaler
        </span>
        <span className="supportContentText">
          16.1. The DOHA CART provides electronic web-based platforms for
          exchanging information between buyers and sellers of products.  
          DOHA CART additionally provides electronic web-based transaction
          platforms for members to place, accept, conclude, manage and fulfill
          their orders within the sites subject to the clauses.  However, for
          any Services, DOHA CART does not represent either the seller or the
          buyer in specific transactions. DOHA CART does not control and is
          not liable or responsible for the quality, safety, lawfulness or
          availability of the products or services offered for sale on the
          sites, the ability of the sellers to complete a sale or the ability
          of buyers to complete a purchase.
        </span>
        <span className="supportContentSubheading">
          17. Partner Responsibilities
        </span>
        <span className="supportContentText">
          17.1. The Partner (Seller) will be required to provide information
          and material (if necessary) about your entity, business or
          products/services as part of the registration process on the sites
          for your access to and use of the services provided by D'BUTLER from
          DOHA CART. 
        </span>
        <span className="supportContentText">
          17.2. The Partner (Seller) represents, warrants and agrees that (a)
          such information and material whether submitted during the
          registration process or thereafter throughout the continuation of
          the use of the Service is true, accurate, update and complete, and
          (b) each partner will maintain and promptly amend all information
          and material to keep it true, accurate, current and complete.
        </span>
        <span className="supportContentText">
          17.3. Upon becoming a trade partner with DOHA CART, the Partner
          agrees to the inclusion of the contact information about Partner in
          DOHA CART database and authorize DOHA CART and its affiliates to
          share the contact information with other users or otherwise use
          Partner's personal information in accordance with the privacy
          policy. 
        </span>
      </div>
    </>
  );
};

// Main Help Component - Modernized
const Help = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="helpRoot">
      <div className="helpLeftMenu">
        <span className="helpMenuTitle">Help & Support</span>
        <div className="helpMenuSearch">
          <input type="text" />
          <div className="supplierSearchIcon">
            <SearchIcon color="inherit" fontSize="default" />
          </div>
        </div>
        <div className="helpMenuList">
          <ul>
            <li>
              <NavLink
                to="/help/help-topics"
                className="help-link"
              >
                About D'Butler
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/help/faq"
                className="help-link"
              >
                FAQ
              </NavLink>
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://digitalbutler.qa/privacy_policy",
                  "_blank"
                );
              }}
            >
              <span className="help-link">Privacy policy</span>
            </li>
            <li>
              <NavLink
                to="/help/termns_and_conditions"
                className="help-link"
              >
                Conditions of use
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/help/contact-us"
                className="help-link"
              >
                Contact us
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
      <div className="helpContent">
        <Routes>
          <Route path="help-topics" element={<HelpTopic />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="termns_and_conditions" element={<Conditions />} />
          <Route path="faq" element={<FAQ />} />
        </Routes>
      </div>
    </div>
  );
};

export default Help;
